(ns practitest.frontend.components2.grid.action-cells
  (:require [reagent.core :as reagent]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.card-view :as card-view]
            [practitest.frontend.components2.buttons :as buttons]))

(defn action-cells
  "Grid row actions shown as icons side by side.
  Takes the same action maps as row-menu - {:label :icon :on-click :disabled? :tooltip :confirmation};
  nil actions are skipped. With :confirmation ({:title :body}), on-click runs only after the user confirms;
  the confirm button defaults to the action :label and the cancel button to \"Cancel\"."
  [_actions]
  (let [state (reagent/atom {})]
    (fn [actions]
      [:div.grid-action-cells
       [card-view/confirmation-dialog
        (reagent/cursor state [:show?])
        (reagent/cursor state [:details])]
       (for [{:keys [label icon on-click disabled? tooltip confirmation]} (remove nil? actions)]
         ^{:key label}
         [buttons/icon-button
          {:icon      [icon]
           :disabled? disabled?
           :tooltip   tooltip
           :on-click  (fn [_]
                        (if confirmation
                          (reset! state
                                  {:show?   true
                                   :details (assoc (merge {:yes-label label
                                                           :no-label  (get-translation "generic.button.cancel" "Cancel")}
                                                          confirmation)
                                                   :on-yes (fn []
                                                             (reset! state {})
                                                             (on-click))
                                                   :on-no #(reset! state {}))})
                          (on-click)))}])])))
